// GreeksDisplay — IV, Delta, Gamma, Theta, Vega display (Angel One Light Theme)
import React from 'react';

export default function GreeksDisplay({ greeks, strikes }) {
  if (!strikes || strikes.length === 0) {
    return (
      <div className="bg-white border border-gray-200 rounded-lg shadow-sm p-4 text-center text-xs text-gray-400">
        No Greeks data available
      </div>
    );
  }

  // Show Greeks for ATM strikes (middle 5)
  const mid = Math.floor(strikes.length / 2);
  const atmStrikes = strikes.slice(Math.max(0, mid - 2), mid + 3);

  return (
    <div className="bg-white border border-gray-200 rounded-lg shadow-sm p-4">
      <h4 className="text-[10px] font-semibold text-gray-600 uppercase tracking-wider mb-3">Option Greeks (ATM)</h4>
      <div className="space-y-2">
        {atmStrikes.map(row => {
          const callGreek = greeks[`${row.strike}_CE`] || {};
          const putGreek = greeks[`${row.strike}_PE`] || {};

          return (
            <div key={row.strike} className="bg-gray-50 rounded-lg p-2.5 border border-gray-200">
              <p className="text-xs font-bold text-blue-600 mb-1.5">Strike {row.strike}</p>
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <p className="text-[9px] text-green-600 font-semibold mb-1">CE Greeks</p>
                  <GreekRow label="IV" value={callGreek.iv} suffix="%" />
                  <GreekRow label="Delta" value={callGreek.delta} />
                  <GreekRow label="Gamma" value={callGreek.gamma} />
                  <GreekRow label="Theta" value={callGreek.theta} />
                  <GreekRow label="Vega" value={callGreek.vega} />
                </div>
                <div>
                  <p className="text-[9px] text-red-500 font-semibold mb-1">PE Greeks</p>
                  <GreekRow label="IV" value={putGreek.iv} suffix="%" />
                  <GreekRow label="Delta" value={putGreek.delta} />
                  <GreekRow label="Gamma" value={putGreek.gamma} />
                  <GreekRow label="Theta" value={putGreek.theta} />
                  <GreekRow label="Vega" value={putGreek.vega} />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

function GreekRow({ label, value, suffix = '' }) {
  return (
    <div className="flex justify-between text-[9px] py-0.5">
      <span className="text-gray-400">{label}</span>
      <span className="font-mono text-gray-900">
        {value != null ? `${parseFloat(value).toFixed(4)}${suffix}` : '—'}
      </span>
    </div>
  );
}
